export default __webpack_public_path__ + "static/innovator-international-f3816231aae64106a1ab2e214b2d6ae3.svg";